/**
 * „Gibt es das schon?“
 *
 * Wer etwas vorschlägt, soll sehen, was schon in der Roadmap steht -- sonst
 * steht dasselbe dreimal drin, mit je einer Stimme, und keiner der drei
 * Einträge sieht wichtig aus. Aus einem doppelten Vorschlag wird so eine
 * zusätzliche Stimme, und das ist die ehrlichere Zahl.
 *
 * Bewusst einfach gehalten: gemeinsame Wörter, ein Bonus für eine Wortfolge,
 * die wörtlich vorkommt. Keine Rechtschreibkorrektur, kein Wortstamm -- das
 * würde bei einem Satz wie „Ton lauter machen“ mehr erfinden als finden.
 */
/** Wörter, die in jedem zweiten Satz stehen und nichts unterscheiden. */
const FUELLWOERTER = new Set([
    'der', 'die', 'das', 'den', 'dem', 'des', 'ein', 'eine', 'einen', 'einem', 'eines', 'und', 'oder', 'aber', 'mit', 'ohne', 'für', 'von', 'zu', 'im', 'in', 'am', 'an', 'auf', 'ist', 'sind', 'wird', 'werden', 'kann', 'man', 'muss', 'soll', 'sollte', 'nicht', 'auch', 'noch', 'mehr', 'wie', 'wenn', 'beim', 'bei', 'als', 'es', 'sich', 'wir', 'ich', 'du',
    // Wörter, die in einer Meldung fast immer stehen: „etwas Neues“, „ganz
    // wichtig“. Sie stiften Treffer, die keine sind.
    'etwas', 'neu', 'neue', 'neues', 'neuen', 'völlig', 'ganz', 'sehr', 'bitte', 'einfach', 'vielleicht', 'machen', 'geht', 'gehen', 'über', 'app', 'schnitt',
]);
function woerter(text) {
    return text
        .toLowerCase()
        .replace(/[^\p{L}\p{N}\s]/gu, ' ')
        .split(/\s+/)
        .filter((w) => w.length > 2 && !FUELLWOERTER.has(w));
}
/**
 * Die ähnlichsten Punkte zuerst. `min` hält Zufallstreffer heraus: ein einzelnes
 * geteiltes Wort ist noch keine Doppelung.
 */
export function aehnlicheItems(frage, items, min = 0.4) {
    const gesucht = woerter(frage);
    if (gesucht.length === 0)
        return [];
    const roh = frage.trim().toLowerCase();
    const treffer = [];
    for (const item of items) {
        const titel = woerter(item.title);
        const alle = new Set([...titel, ...woerter(item.detail ?? '')]);
        if (alle.size === 0)
            continue;
        const gemeinsam = gesucht.filter((w) => alle.has(w)).length;
        // Am Anteil der *gesuchten* Wörter gemessen: ein langer Punkt in der Liste
        // soll nicht dadurch gewinnen, dass er viele Wörter hat.
        // Ein einziges geteiltes Wort aus einem ganzen Satz ist Zufall. Bei einer
        // kurzen Frage („DaVinci“) ist dasselbe Wort dagegen die ganze Frage --
        // deshalb hängt die Hürde an der Länge.
        const noetig = gesucht.length >= 3 ? 2 : 1;
        let score = gemeinsam >= noetig ? gemeinsam / gesucht.length : 0;
        // Steht die Frage wörtlich im Titel, ist es fast sicher dasselbe.
        if (roh.length > 4 && item.title.toLowerCase().includes(roh))
            score = Math.max(score, 0.9);
        // Ein Treffer im Titel wiegt schwerer als einer im Fließtext.
        const imTitel = gesucht.filter((w) => titel.includes(w)).length;
        score += (imTitel / gesucht.length) * 0.15;
        if (score >= min)
            treffer.push({ item, score: Math.min(1, score) });
    }
    return treffer.sort((a, b) => b.score - a.score);
}
//# sourceMappingURL=aehnlich.js.map